export const JOB_FILTERS_STORAGE_KEY = "job_list_filters";
export const JOB_PAGE_STORAGE_KEY = "job_list_page";
export const JOB_DISPLAY_COLUMNS_STORAGE_KEY = "job_display_columns";
export const JOB_ADVANCED_FILTERS_STORAGE_KEY = "job_advanced_filters";
export const JOB_APPLIED_CONDITION_NAME_STORAGE_KEY = "job_applied_condition_name";
export const JOB_APPLIED_CONDITION_ID_STORAGE_KEY = "job_applied_condition_id";
export const JOB_SORT_STORAGE_KEY = "job_list_sort";
export const JOB_SELECTED_STORAGE_KEY = "job_selected";
export const JOB_SELECT_ALL_STORAGE_KEY = "job_select_all";
export const JOB_DEFAULT_SEEDED_STORAGE_KEY = "job_default_seeded";

export const JOB_DELETE_CONFIRM_MESSAGE = "求人情報を削除しますがよろしいですか？この操作は元に戻せません。ご注意ください。";
export const JOB_DELETE_UNDELETABLE_MESSAGE = "案件に人材が紐づけられており削除できません。案件を修正の上、改めて削除してください。";
export const JOB_BULK_DELETE_CONFIRM_MESSAGE = (count: number) =>
  `選択した${count}件の求人を削除してもよろしいですか？この操作は元に戻せません。ご注意ください。`;

export const JOB_EXPORT_FAILED_MESSAGE = "求人票の出力に失敗しました。";

export const TAG_DELETE_IN_USE_MESSAGE = (tagLabel: string, total: number) => `タグ「${tagLabel}」は${total}件の求人で使用されています。`;
export const TAG_DELETE_UNASSIGN_MESSAGE = "削除すると、これらの求人からタグが解除されます。";
export const TAG_DELETE_CONFIRM_MESSAGE = "削除してもよろしいですか？";
export const TAG_DELETE_SIMPLE_CONFIRM_MESSAGE = (tagLabel: string) => `タグ「${tagLabel}」を削除しますか？`;
export const TAG_DELETE_NEWLY_ADDED_MESSAGE = "以下の求人が新たに対象に追加されました。\nご確認のうえ、もう一度「削除する」を押してください。";